<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">Skip Refund Service #{{service.booking_id}}/{{service.service_id}}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">Type</label>
              <select name="type" id="type" v-model="skip.type" class="select is-fullwidth">
                <option value="">Select a type</option>
                <option value="0" v-if="parseInt(service.refund_client) == 0 && (service.invoice_id != null && parseInt(service.invoice_payment) == 1)">Client</option>
                <option value="1" v-if="parseInt(service.refund_provider) == 0 && (service.payment_id != null && parseInt(service.payment_payment) == 1)">Provider</option>
                <option value="2" v-if="(parseInt(service.refund_provider) == 0 && (service.payment_id != null)) && (parseInt(service.refund_client) == 0 && (service.invoice_id != null))">All</option>
              </select>
            </p>
          </div>
        </div>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">Reason</label>
              <textarea :class="{'textarea': true, 'is-danger': errors.has('reason') }" name="reason" id="reason" placeholder="" v-model="skip.reason" v-validate="'required'"></textarea>
              <span v-show="errors.has('reason')" class="help is-danger">{{ errors.first('reason') }}</span>
            </p>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" @click="close(true)">Cancel</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any() || inProgress || skip.type == null, 'is-loading': inProgress}" @click="skipAction()">Skip</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import Datepicker from 'vue-bulma-datepicker'
  export default {
    props: {
      context: {
        type: Object
      },
      service: {
        type: Object
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        skip: {
          type: '',
          reason: '',
          service_id: null
        },
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
        this.skip.service_id = this.service.id
      })
    },
    methods: {
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      skipAction () {
        this.inProgress = true
        if (this.skip.type !== '') {
          if (window.confirm('Are you sure you want skip refund?')) {
            this.context.$http.post(this.context.$store.state.config.apiURL + '/finances/skip', this.skip).then((response) => {
              if (response.body.hasOwnProperty('error')) {
                this.error = response.body.description
                this.inProgress = false
              } else {
                this.inProgress = false
                this.close(false, 'ok')
              }
            }, (response) => {
              this.inProgress = false
              this.error = response.body
            })
          } else {
            this.inProgress = false
          }
        } else {
          this.error = 'Please set type!'
          this.inProgress = false
          return false
        }
      }
    },
    components: {
      Datepicker
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// SkipRefund.vue?7f8a1c10